import React from 'react';

import { useIntl } from 'react-intl';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useAiWidgetConfig } from '../../controllers/ai-widget-config-context';
import { AiCornerAgent } from '../ai-corner-agent';
import { AiSearchTrigger, AiSearchTriggerFloating } from '../ai-search-trigger';

const useWidgetLocale = () => {
	const { locale } = useIntl();

	// The widget runs in an iframe and cannot inherit React Intl context from the host application.
	// Forward the resolved application locale so its UI matches the surrounding experience.
	return fg('csm_widget_embed_i18n') ? locale : undefined;
};

/**
 * AiSearchTrigger with props from the AiWidgetConfigProvider
 */
export const AiSearchTriggerWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();
	const locale = useWidgetLocale();

	return (
		<AiSearchTrigger
			locale={locale}
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
			widgetTheme={supportWidgetConfig.widgetTheme}
		/>
	);
};

/**
 * AiSearchTriggerFloating with props from the AiWidgetConfigProvider
 */
export const AiSearchTriggerFloatingWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();
	const locale = useWidgetLocale();

	return (
		<AiSearchTriggerFloating
			locale={locale}
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
			widgetTheme={supportWidgetConfig.widgetTheme}
		/>
	);
};

/**
 * AiCornerAgent with props from the AiWidgetConfigProvider
 */
export const AiCornerAgentWithContext = (): React.JSX.Element => {
	const { supportWidgetConfig } = useAiWidgetConfig();
	const locale = useWidgetLocale();

	return (
		<AiCornerAgent
			locale={locale}
			site={supportWidgetConfig.site}
			siteId={supportWidgetConfig.siteId}
			widgetId={supportWidgetConfig.widgetId}
		/>
	);
};
